module.exports = __webpack_public_path__ + "img/faceempty.a1dafde6.svg";